var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element)?_c('v-col',{staticClass:"pa-0 ma-0 mb-3",attrs:{"no-gutters":"","align":"center"}},[_c('v-textarea',{staticClass:"mb-2",attrs:{"label":"Frage eingeben...","rows":"2","outlined":"","hide-details":"","dense":""},model:{value:(_vm.element.text),callback:function ($$v) {_vm.$set(_vm.element, "text", $$v)},expression:"element.text"}}),_c('CompSurveyComment',{attrs:{"text":_vm.element.text,"compSettings":`{
      "maxlength": ${_vm.element.max},
      "questionId": 1
    }`}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }